import React, { useEffect } from 'react'
import {
  CustomCalendar,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import useExtratoMovimentacaoPorProduto, {
  EXTRATO_XLSX,
  LOADING_MESSAGE,
} from './ExtratoMovimentacaoPorProdutoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

function ExtratoMovimentacaoPorProduto({ dispatch, history, selectedTp }) {
  // State
  const { state, localDispatch } = useExtratoMovimentacaoPorProduto()

  // Erro Handler
  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Loading Events
  useEffect(() => {
    if (state.loadingMessage === LOADING_MESSAGE.LOADING_PRODUCTS) {
      dispatch(showLoadingBox('Carregando os Produtos . . . ', 'Aguarde'))
      localDispatch.getProducts(state.selectedCompany)
    }
    if (state.loadingMessage === LOADING_MESSAGE.NONE) {
      dispatch(hideLoadingBox())
    }
    if (state.loadingMessage === LOADING_MESSAGE.LOADING_EXTRATO_XLSX) {
      dispatch(showLoadingBox('Gerando o extrato em XLSX . . . ', 'Aguarde'))
    }
    if (state.loadingMessage === LOADING_MESSAGE.LOADING_EXTRATO_PDF) {
      dispatch(showLoadingBox('Gerando o extrato em PDF . . . ', 'Aguarde'))
    }
  }, [state.loadingMessage])

  // Quando produto for selecionado
  useEffect(() => {
    state.selectedProduto &&
      localDispatch.getExtrato(
        state.loadingMessage,
        state.selectedProduto,
        state.periodo.dataInicial,
        state.periodo.dataFinal,
        selectedTp,
      )
  }, [state.selectedProduto])
  // Render
  return (
    <div>
      <PageHeader>8.19 - Extrato de Movimentação Por Produto</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => { }} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                label="Empresa"
                filter={true}
                optionLabel={'name'}
                options={getEmpresas()}
                value={state.selectedCompany}
                onChange={value => localDispatch.onCompanyChange(value, selectedTp)}
              />
            </div>
            {state.selectedCompany ? (
              <div className="p-col-4 p-grid" style={{ marginTop: 1 }}>
                <div className="p-col-3">
                  <CustomCalendar
                    label="Período Inicial"
                    value={state.periodo.dataInicial}
                    onChange={value => localDispatch.onDateChange(value, state.periodo.dataFinal)}
                  />
                </div>
                <div className="p-col-3">
                  <CustomCalendar
                    label="Período Final"
                    value={state.periodo.dataFinal}
                    onChange={value => localDispatch.onDateChange(state.periodo.dataInicial, value)}
                  />
                </div>
              </div>
            ) : null}
          </div>
          <div className="p-col-12">
            <DataTable
              value={state.listaProdutos}
              header={<CustomDataTableHeader onChange={localDispatch.onDataTableSearchChange} />}
              globalFilter={state.globalFilter}
              paginator={true}
              rows={10}
              emptyMessage="Nenhum Produto. Selecione a empresa desejada"
            >
              <Column field="product_code" header="Código" style={tableCellCentered(150)} />
              <Column field="name" header="Produto" />
              <Column
                header="Menu"
                style={tableCellCentered(70)}
                body={produto => (
                  <ThreeDots
                    items={[EXTRATO_XLSX]}
                    // items={[EXTRATO_XLSX, EXTRATO_PDF]}
                    onClick={item => localDispatch.onMenuItemClicked(item, produto)}
                  />
                )}
                bodyStyle={tableCellCentered()}
              />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ExtratoMovimentacaoPorProduto))
